import axios from "@/lib/axios";

const getNewLostNonWarranty = () => {
  return axios.get("/facility/facility_agreements/lost_non_warranty/new");
}

export default getNewLostNonWarranty;